import AddressAutocomplete from 'google-address-autocomplete';
import { Dropdown } from '../components/Dropdown.js';

export class GoogleAddressAutocomplete {
    constructor(containerElement) {
        let element = $('#' + containerElement);
        if (element.is(':visible')) {
            let address = new AddressAutocomplete('#' + containerElement + ' .vs_address1', (results, rawResults) => {
                const addressComponents = rawResults["address_components"] || [];
                const autocompleteAddress = {};
                for (let component of addressComponents) {
                    for (let type of component.types) {
                        if (!autocompleteAddress[type]) {
                            autocompleteAddress[type] = component;
                        }
                    }
                }

                // City Precedence
                let cityName = results["cityName"]?.trim();
                if (!cityName) {
                    const cityPrecedence = [
                        "locality",
                        "administrative_area_level_3",
                        "neighborhood",
                        "sublocality_level_1"
                    ];
                    for (let type of cityPrecedence) {
                        if (autocompleteAddress[type]) {
                            cityName = autocompleteAddress[type].long_name;
                            break;
                        }
                    }
                }

                let subpremise = results['subpremise'] || autocompleteAddress['subpremise']?.long_name;
                let stateName = results['stateAbbr'] || autocompleteAddress['administrative_area_level_1']?.short_name;
                let countryName = results['countryAbbr'] || autocompleteAddress['country']?.short_name;

                if (app.appData.configs.CITY_SPECIAL_CHAR_VALIDATION ?? false) {
                    cityName = cityName ? cityName.replace(/[^a-zA-Z\s]/g, "") : cityName;
                }

                if (containerElement == 'attendance_add_via_form_address') {
                    this.buildStateDD(
                        element.find('[id*=state], [name*=state]'),
                        'state',
                        countryName,
                        stateName
                    );
                }

                element.find('[id*=city], [name*=city]').val(cityName);
                element.find('[id*=zip], [name*=zip]').val(results['zipCode']);
                element.find('[id*=country], [name*=country]').val(countryName);
                element.find('[id*=state], [name*=state]').val(stateName);

                element.find('[id*=place_id], [name*=place_id]').val(rawResults['place_id']);
                element.find('[id*=lat], [name*=lat]').val(results['coordinates']['lat']);
                element.find('[id*=lng], [name*=lng]').val(results['coordinates']['lng']);

                let address1 = (results['streetNumber']+' '+results['streetName']).trim();
                if (!address1) {
                    address1 = rawResults['address_components'][0]?.long_name;
                }
                // Including the subpremise to append the residential address as #54235
                if (subpremise) {
                    address1 = address1 + ' ' + subpremise;
                }
                let uspsaddress1 = element.find('[id*=address1], [name*=address1]');
                if ((app.appData.configs.GOOGLE_ADDRESS_VALIDATION_USPS ?? false) && countryName === 'US') {
                    this.validateUSPSAddress(
                        element,
                        address1,
                        cityName,
                        stateName,
                        results['zipCode'],
                        countryName,
                        uspsaddress1
                    );
                }
                else {
                    element.find('[id*=city], [name*=city]').val(cityName);
                    element.find('[id*=zip], [name*=zip]').val(results['zipCode']);
                    element.find('[id*=country], [name*=country]').val(countryName);
                    element.find('[id*=state], [name*=state]').val(stateName);
                    element.find('[id*=address1], [name*=address1]').val(address1);
                    element.find('[id*=place_id], [name*=place_id]').val(rawResults['place_id']);
                    element.find('[id*=lat], [name*=lat]').val(results['coordinates']['lat']);
                    element.find('[id*=lng], [name*=lng]').val(results['coordinates']['lng']);
                    element.find('.vs_address1').trigger('change');
                }
            });

            address.initializeAutocomplete();
        }
    }

    buildStateDD(stateContainer, ddName, countryCode = 'US', selectedStateCode = '') {
        selectedStateCode = selectedStateCode || '';

        return $.ajax({
            url: 'api/states/' + countryCode,
            method: 'get'
        }).done((data) => {

            // Remove any existing select before creating a new one
            stateContainer.find('select').remove();
            stateContainer.empty();

            this.stateDD = new Dropdown(data)
                .addClass('input-group-text')
                .addClass('form-control-sm')
                .addClass('address-field')
                .label('Select a state...')
                .draw(stateContainer, 'alpha2', 'name', ddName);

            let $select = stateContainer.find('select');

            // Auto-select if only one state returned
            if (data.length === 1) {
                $select.val(data[0].alpha2);
            }

            // Apply chosen state from Google autocomplete
            if (selectedStateCode) {
                $select.val(selectedStateCode);
            }

            $select.trigger('change');
        });
    }

    validateUSPSAddress(element, address1, cityName, stateName, zipCode, countryName, uspsaddress1) {
        const validationPayload = {
            address: {
                regionCode: countryName,
                locality: cityName,
                administrativeArea: stateName,
                postalCode: zipCode,
                addressLines: [address1]
            },
            enableUspsCass: true
        };

        uspsaddress1.data('usps-validating', true);

        fetch(`https://addressvalidation.googleapis.com/v1:validateAddress?key=${googleMapsApiKey}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(validationPayload)
        })
            .then(response => response.json())
            .then(data => {
                const usps = data.result?.uspsData || {};
                const verdict = data.result?.verdict || {};
                const std = usps.standardizedAddress;
                const validationMessages = JSON.parse(app.appData.configs.ADDRESS_VALIDATION_MESSAGES) || {};

                uspsaddress1.removeAttr('pattern data-pattern title');
                uspsaddress1.removeClass('pattern-valid');
                uspsaddress1.get(0)?.setCustomValidity('');

                if (!usps || !std) {
                    uspsaddress1.addClass('is-invalid').data('usps-invalid', true);
                    uspsaddress1.next('.invalid-feedback').remove();
                    uspsaddress1.after(`<div class="invalid-feedback d-block">${validationMessages['DEFAULT']}</div>`);
                    uspsaddress1.data('usps-validating', false);
                    uspsaddress1.trigger('uspsValidationDone');
                    return;
                }

                const dpvConfirmation = usps.dpvConfirmation;
                const possibleNextAction = verdict.possibleNextAction;
                const dpvFootnote = usps.dpvFootnote;
                const placeId = data.result?.geocode?.placeId || null;
                const lat = data.result?.geocode?.location?.latitude || null;
                const lng = data.result?.geocode?.location?.longitude || null;
                const zipCode = std.zipCodeExtension ? `${std.zipCode}-${std.zipCodeExtension}` : std.zipCode;
                const metaData = data.result?.metadata || {};
                const isEmptyMetadata = metaData && Object.keys(metaData).length === 0;
                const isBusiness = metaData?.business ?? true;
                const isResidential = metaData?.residential ?? false;
                const OPCO = app.appData.curPosition?.opco_code;
                const opcoCode = OPCO.trim().toLowerCase();
                const opcoslist = app.appData.configs.NON_BLOCKING_POPUP_OPCO_LIST;
                const opcos = typeof opcoslist === 'string' ? opcoslist.replace(/[[\]']/g, '').split(',').map(v => v.trim().toLowerCase()) : Array.isArray(opcoslist) ? opcoslist.map(v => v.toLowerCase()) : [];
                const allowResidentialForOpco = opcos.includes(opcoCode) && isResidential;
                const isValidMetadata = isEmptyMetadata || isBusiness || allowResidentialForOpco;

                element.find('[id*=city], [name*=city]').val(std.city);
                element.find('[id*=zip], [name*=zip]').val(zipCode);
                element.find('[id*=country], [name*=country]').val('US');
                element.find('[id*=state], [name*=state]').val(std.state);
                element.find('[id*=address1], [name*=address1]').val(std.firstAddressLine);
                element.find('[id*=address2], [name*=address2]').val(std.secondAddressLine || '');
                element.find('[id*=place_id], [name*=place_id]').val(placeId);
                element.find('[id*=lat], [name*=lat]').val(lat);
                element.find('[id*=lng], [name*=lng]').val(lng);
                element.find('.vs_address1').trigger('change');

                const isValidUSPS = isValidMetadata &&
                    ((dpvConfirmation === 'Y' && possibleNextAction === 'ACCEPT') ||
                    (dpvConfirmation === 'Y' && possibleNextAction === 'CONFIRM' && ['AABB', 'AAU1', 'AABBTA', 'AABBRR'].includes(dpvFootnote)
                       ) ||
                    (dpvConfirmation === 'S' && ['ACCEPT', 'CONFIRM'].includes(possibleNextAction) &&
                        ['AABB', 'AAU1', 'AABBTA', 'AABBRR', 'AABBCC', 'AAC1R7'].includes(dpvFootnote)) ||
                    (['ACCEPT', 'CONFIRM'].includes(possibleNextAction) && ['AAM3'].includes(dpvFootnote)) ||
                    (dpvConfirmation === 'D' && dpvFootnote === 'AAN1') ||
                    (dpvConfirmation === 'S' && possibleNextAction === 'ACCEPT' && dpvFootnote === 'AAC1') ||
                    (possibleNextAction == 'ACCEPT' && ['A1'].includes(dpvFootnote)));

                uspsaddress1.next('.invalid-feedback').remove();
                uspsaddress1.removeClass('is-invalid').data('usps-invalid', false);
                uspsaddress1.get(0)?.setCustomValidity('');

                if (!isValidUSPS) {
                    let message = '';
                    if (possibleNextAction === 'CONFIRM_ADD_SUBPREMISES' || ['AAN1', 'AAC1', 'AABBCC', 'AABBCCR7'].includes(dpvFootnote)) {
                        message = validationMessages['CONFIRM_ADD_SUBPREMISES'];
                    } else {
                        message = validationMessages[possibleNextAction] || validationMessages['DEFAULT'];
                    }
                    uspsaddress1.addClass('is-invalid').data('usps-invalid', true);
                    uspsaddress1.after(`<div class="invalid-feedback d-block">${message}</div>`);
                } else {
                    element.find('.invalid-feedback').remove();
                    uspsaddress1.removeClass('is-invalid').data('usps-invalid', false);

                    let address1Input = element.find('[id*=address1], [name*=address1]');
                    let address2Input = element.find('[id*=address2], [name*=address2]');

                    //Replace special characters with a space for validated usps address
                    address1Input
                        .val(this.replaceSpecialChar(address1Input.val()));
                    address2Input
                        .val(this.replaceSpecialChar(address2Input.val()));
                }
                uspsaddress1.get(0)?.setCustomValidity('');
                uspsaddress1.data('usps-validating', false);
                uspsaddress1.trigger('uspsValidationDone');
            })
            .catch(err => console.error('Google Address Validation failed', err));
    }

    replaceSpecialChar(text) {
        return text
            ? text.replace(/[~!@#$%^&*()_+=`[\]{}\\|;:"<>?,]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
            : '';
    }
}